import { css } from 'styled-components';
import { COLORS } from '../../design/tokens';

const onError = ({ error }) =>
  error
    ? css`
        & .ant-calendar-picker,
        .ant-calendar-picker-input {
          background-color: ${COLORS.DATEPICKER.ERROR.BACKGROUND};
          border-color: ${COLORS.DATEPICKER.ERROR.BORDER};
          color: ${COLORS.DATEPICKER.ERROR.TEXT};
          box-shadow: none;
        }

        &:hover .ant-calendar-picker-input {
          border-color: ${COLORS.DATEPICKER.ERROR.HOVER} !important;
        }
      `
    : '';

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    margin-top: 8px !important;
  `,
  datepickerContainer: css`
    flex-direction: row;
    display: flex;
    align-items: center;
    && {
      .ant-calendar-picker-clear {
        padding-top: 5px;
      }
      .ant-calendar-picker-clear,
      .ant-calendar-picker-icon {
        width: 24px;
        height: 24px;
        position: absolute;
        left: 8px;
        top: 15px;
      }

    }
  `,
  label: css`
    text-transform: uppercase;
    letter-spacing: 0.6px;
    line-height: 22px;
    font-weight: 600;
    font-size: 14px;
  `,
  datepicker: css`
    margin-right: 16px !important;
    border-radius: 0;
    border-width: 2px;
    border-color: ${COLORS.DATEPICKER.BASE.BORDER};
    width: 160px;
    margin-top: 8px !important;
    margin-bottom: 8px !important;

    &.ant-calendar-picker:hover .ant-calendar-picker-input:not(.ant-input-disabled) {
      border-color: ${COLORS.DATEPICKER.HOVER.BORDER};
    }

    & .ant-input {
      &::placeholder {
        color: #848BA7;
        font-family: "Open Sans",sans-serif;
      }
      font-family: "Open Sans",sans-serif;
      font-size: 16px;
      letter-spacing: 0;
      line-height: 26px;
      height: 40px;
      width: 160px;
      padding-top: 2px;
      padding-left: 40px;
      border-radius: 0;
      border-width: 2px !important;
      border-color: ${COLORS.DATEPICKER.BASE.BORDER};
    }

    &.ant-calendar-picker:hover .ant-calendar-picker-input:not(.ant-input-disabled).ant-input:hover,
    .ant-calendar-picker-input.ant-input:focus,
    .ant-calendar-picker-input.ant-input:hover {
      border-width: 2px !important;
      border-color: ${COLORS.DATEPICKER.HOVER.BORDER}; !important;
    }



    ${onError}
  `,
  message: css`
    color: ${props =>
      props.error ? COLORS.DATEPICKER.ERROR.TEXT : COLORS.DATEPICKER.BASE.TEXT};
    margin-top: 6px;
  `
};

export default styles;
